import type { Styles } from '@adornis/ass/style.js';
import { getAllEntities } from '@adornis/baseql/operations/mongo.js';
import { institutionListConfig } from '@adornis/bh-buildify/client/nodes/institution-list/config.js';
import { institutionListingPageBuildifyPreset } from '@adornis/buchungsheld-db/_buildify-presets.js';
import { Institution } from '@adornis/buchungsheld-db/entities/institution.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@adornis/chemistry/elements/components/x-loader.js';
import { fullEditorConfig } from '@adornis/html-based-buildify/client/editor/presets/full-editor.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { bhBuldifyEditor, bhBuldifyEditorActions } from '../../../components/bh-buildify-editor.js';
import { GlobalSettingsAdapter } from './GlobalSettingsAdapter.js';

@customElement('bh-page-admin-global-settings-institution-overview-editor')
export class BHPageAdminGlobalSettingsInstitutionOverviewEditor extends GlobalSettingsAdapter {
  @state() private institutions = new RXController(
    this,
    getAllEntities(Institution)({
      _id: 1,
      name: 1,
      hidden: 1,
    }),
  );

  override render() {
    const settingsController = this._formControllerV2;
    const settings = settingsController.document;
    if (!settings || !settingsController || !settingsController.document) return html` <x-loader></x-loader> `;

    const actions = bhBuldifyEditorActions(this, settings, 'institutionOverview', institutionListingPageBuildifyPreset);
    for (const action of actions) this.exposeAction(action.icon, action);

    return html`
      <x-flex space="md">
        <x-dropdown-multiselection
          placeholder="Aktive Institutionen"
          .selectables=${this.institutions.value?.map(i => i._id) ?? []}
          .renderString=${item => this.institutions.value?.find(i => i._id === item)?.name ?? 'error: not found'}
          .value=${this.institutions.value?.filter(inst => !inst.hidden).map(inst => inst._id) ?? []}
          @value-picked=${async (e: CustomEvent) => {
            for (const inst of this.institutions.value ?? []) {
              const shouldBeHidden = !e.detail.value.includes(inst._id);
              if (inst.hidden !== shouldBeHidden) {
                inst.hidden = shouldBeHidden;
                await inst.save();
              }
            }
          }}
        ></x-dropdown-multiselection>

        ${bhBuldifyEditor(settings, 'institutionOverview', {
          prosemirrorConfig: [...fullEditorConfig(), institutionListConfig],
          defaultDesign: institutionListingPageBuildifyPreset,
        })}
      </x-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
